import { Component, OnInit, Inject, HostBinding } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export const TRANSFER_UNLOCK = 'TRANSFER_UNLOCK';
export const ACTIVATE_UNLOCK = 'ACTIVATE_UNLOCK';

@Component({
    selector: 'app-dlg-store-cpu-unlock',
    templateUrl: './dlg-store-cpu-unlock.component.pug',
    styleUrls: ['./dlg-store-cpu-unlock.component.less'],
})
export class DlgStoreCpuUnlockComponent implements OnInit {
    @HostBinding('class.effect--grayscale') disabled: boolean = false;

    constructor(
        public _dialogRef: MatDialogRef<DlgStoreCpuUnlockComponent>,

        @Inject(MAT_DIALOG_DATA) public data: any
    ) { }

    ngOnInit() {
        // This is hack to close by backdrop.
        const overlayWrapper = this._dialogRef['_overlayRef'].overlayElement.parentElement;

        overlayWrapper.addEventListener('click', ({ target }) => {
            if (overlayWrapper !== target) {
                return;
            }

            this.onClose();
        });
    }

    onClose() {
        this.data.close();
    }

    onTransfer(payload: any) {
        this.data.transfer(payload);
    }

    onActivate(payload: any) {
        this.data.activate(payload);
    }
}
